import { LiveData, Service } from '@toeverything/infra';

import { CalendarIntegration } from '../entities/calendar';
import { DevtoIntegration } from '../entities/devto';
import { GitHubIntegration } from '../entities/github';
import { ReadwiseIntegration } from '../entities/readwise';
import { IntegrationWriter } from '../entities/writer';

export class IntegrationService extends Service {
  writer = this.framework.createEntity(IntegrationWriter);
  readwise = this.framework.createEntity(ReadwiseIntegration, {
    writer: this.writer,
  });
  calendar = this.framework.createEntity(CalendarIntegration);
  devto = this.framework.createEntity(DevtoIntegration);
  github = this.framework.createEntity(GitHubIntegration);

  constructor() {
    super();
  }

  importing$ = LiveData.computed(get => {
    return get(this.readwise.importing$);
  });
}
